export default "__VITE_ASSET__DmLuVOln__"